// const baseApiurl = `https://humansyncdemo-axe7a7dzdtbgf0gm.centralus-01.azurewebsites.net/api/`;
const baseApiurl = `https://ara-payroll-cyezfwb6d9g0h8ew.centralus-01.azurewebsites.net/api/`; /* Live */


const CHAT_LIVE_URL = 'https://arahumansyncchat-g2hgefc2bba7d9g2.centralindia-01.azurewebsites.net';

const chatBaseUrl = baseApiurl.includes('humansyncdemo')
    ? baseApiurl.replace(/\/a  pi\/?$/, '')
    : CHAT_LIVE_URL;

// The chat service is a separate server; http.js uses this to tell its answers apart from the payroll server's.
export const ChatBaseUrl = chatBaseUrl;
const Chat = `${chatBaseUrl}/api/Chat/`;
const GroupChatSettings = `${chatBaseUrl}/api/GroupChatSettings/`;
export const ChatHubUrl = `${chatBaseUrl}/hubs/chat`;

const Auth = `${baseApiurl}Auth/`;
const Setup = `${baseApiurl}Setup/`;
const Dashboard = `${baseApiurl}Dashboard/`;
const UserType = `${baseApiurl}UserType/`;
const FinancialYear = `${baseApiurl}FinancialYear/`;
const Access = `${baseApiurl}Access/`;
const ExcelImport = `${baseApiurl}ExcelImport/`;
const Employee = `${baseApiurl}Employee/`;
const LoginIdFormat = `${baseApiurl}LoginIdFormat/`;
const LeavePolicy = `${baseApiurl}LeavePolicy/`;
const EmployeeAttendance = `${baseApiurl}EmployeeAttendance/`;
const ShiftAssignment = `${baseApiurl}ShiftAssignment/`;
const Overtime = `${baseApiurl}Overtime/`;
const SalaryAdvance = `${baseApiurl}SalaryAdvance/`;
const EmployeeDocument = `${baseApiurl}EmployeeDocument/`;
const Department = `${baseApiurl}Department/`;
const Designation = `${baseApiurl}Designation/`;
const Recruitment = `${baseApiurl}Recruitment/`;
const Careers = `${baseApiurl}Careers/`;
const PublicCareers = `${baseApiurl}public/careers/`;
const Inbox = `${baseApiurl}Inbox/`;
const BusinessEntity = `${baseApiurl}BusinessEntity/`;
const DocumentManagement = `${baseApiurl}DocumentManagement/`;
const OrganisationDocuments = `${baseApiurl}OrganisationDocuments/`;
const ClientLocation = `${baseApiurl}ClientLocation/`;
const Resignation = `${baseApiurl}Resignation/`;
const Increment = `${baseApiurl}Increment/`;
const MyProfile = `${baseApiurl}MyProfile/`;
const PunchRequest = `${baseApiurl}PunchRequest/`;
const LocationTracking = `${baseApiurl}LocationTracking/`;
const SitePunch = `${baseApiurl}SitePunch/`;
const payRoll = `${baseApiurl}payRoll/`;
const payrollCycle = `${baseApiurl}PayrollCycle/`;
const leavePolicy = `${baseApiurl}leavePolicy/`;
const leave = `${baseApiurl}leave/`;
const biometrics = `${baseApiurl}biometrics/`;
const MyDocument = `${baseApiurl}MyDocument/`;
const DeviceInfo = `${baseApiurl}DeviceInfo/`;
const staffManagement = `${baseApiurl}staffManagement/`;

export const PostLogin = `${Auth}PostLogin`;
export const PostRefreshToken = `${Auth}PostRefreshToken`;
export const PostLogout = `${Auth}PostLogout`;
export const PostChangePassword = `${Auth}PostChangePassword`;
export const PostChangeEmail = `${Auth}PostChangeEmail`;
export const PostUpdateProfile = `${Auth}PostUpdateProfile`;

export const GetEntitySetupStatus = `${Setup}GetEntitySetupStatus`;

export const GetDashboard = `${Dashboard}GetDashboard`;
export const GetMasterDashboard = `${Dashboard}GetMasterDashboard`;
export const GetActionRequired = `${Dashboard}GetActionRequired`;
export const GetMyDashboard = `${Dashboard}GetMyDashboard`;

export const GetUserTypes = `${UserType}GetUserTypes`;
export const PostUserType = `${UserType}PostUserType`;
export const UpdateUserType = `${UserType}UpdateUserType`;
export const DeleteUserType = `${UserType}DeleteUserType`;
export const GetUsersByUserType = `${UserType}GetUsersByUserType`;

export const GetModules = `${Access}GetModules`;
export const GetRoleAccess = `${Access}GetRoleAccess`;
export const UpdateRoleAccess = `${Access}UpdateRoleAccess`;

export const GetFinancialYearConfig = `${FinancialYear}GetFinancialYearConfig`;
export const PostFinancialYearConfig = `${FinancialYear}PostFinancialYearConfig`;

export const GetImportTemplate = `${ExcelImport}GetImportTemplate`;
export const ValidateImport = `${ExcelImport}ValidateImport`;
export const ImportEmployees = `${ExcelImport}ImportEmployees`;

export const GetEmployees = `${Employee}GetEmployees`;
export const GetEmployeeById = `${Employee}GetEmployeeById`;
export const PostEmployee = `${Employee}PostEmployee`;
export const UpdateEmployee = `${Employee}UpdateEmployee`;
export const InactivateEmployee = `${Employee}InactivateEmployee`;
export const AddRelievedEmployee = `${Employee}AddRelievedEmployee`;
export const SetEmployeeLoginPassword = `${Employee}SetEmployeeLoginPassword`;
export const UpdateEmployeeUserType = `${Employee}UpdateEmployeeUserType`;
export const GetEmployeeCredentials = `${Employee}GetEmployeeCredentials`;

export const GetLoginIdFormat = `${LoginIdFormat}GetLoginIdFormat`;
export const UpdateLoginIdFormat = `${LoginIdFormat}UpdateLoginIdFormat`;

export const PostLeavePolicy = `${LeavePolicy}PostLeavePolicy`;
export const GetLeavePolicyByFinancialYear = `${LeavePolicy}GetLeavePolicy`;
export const PostLeaveType = `${LeavePolicy}PostLeaveType`;
export const GetLeaveTypes = `${LeavePolicy}GetLeaveTypes`;
export const GetLeaveTypeByID = `${LeavePolicy}GetLeaveTypeByID`;
export const UpdateLeaveTypeByID = `${LeavePolicy}UpdateLeaveTypeByID`;
export const DeleteLeaveTypeByID = `${LeavePolicy}DeleteLeaveTypeByID`;
export const PostWorkingCalendar = `${LeavePolicy}PostWorkingCalendar`;
export const GetWorkingCalendar = `${LeavePolicy}GetWorkingCalendar`;
export const GetEmployeeLeaveBalance = `${LeavePolicy}GetEmployeeLeaveBalance`;

export const GetEmployeeAttendance = `${EmployeeAttendance}GetEmployeeAttendance`;
export const PostEmployeeManualAttendance = `${EmployeeAttendance}PostEmployeeManualAttendance`;
export const GetEmployeeAttendanceAudit = `${EmployeeAttendance}GetEmployeeAttendanceAudit`;
export const GetEmployeeAttendanceOverview = `${EmployeeAttendance}GetEmployeeAttendanceOverview`;
export const GetAttendanceRegister = `${EmployeeAttendance}GetAttendanceRegister`;
export const GetAttendanceEmployeeBefore = `${EmployeeAttendance}GetAttendanceEmployeeBefore`;

export const GetUnassignedEmployees = `${ShiftAssignment}GetUnassignedEmployees`;
export const GetShiftAssignedEmployees = `${ShiftAssignment}GetShiftAssignedEmployees`;
export const AssignEmployeeToShift = `${ShiftAssignment}AssignEmployeeToShift`;
export const UpdateAssignedEmployee = `${ShiftAssignment}UpdateAssignedEmployee`;
export const UnassignEmployee = `${ShiftAssignment}UnassignEmployee`;

export const getPayrollCycle = `${payrollCycle}GetCycle`;
export const getPayrollRegister = `${payrollCycle}GetRegister`;
export const getPayrollPayslip = `${payrollCycle}GetPayslip`;
// The payslip document itself (earnings, deductions and the rule breakdown),
// as opposed to payRoll/GetMyPayslip which returns the request rows.
export const GetMyPayslipDocument = `${payrollCycle}GetMyPayslip`;
export const postLockAttendancePayrollCycle = `${payrollCycle}PostLockAttendance`;
export const postCalculatePayrollCycle = `${payrollCycle}PostCalculate`;
export const postApprovePayrollCycle = `${payrollCycle}PostApprove`;
export const postMarkCreditedPayrollCycle = `${payrollCycle}PostMarkCredited`;
export const postRollbackPayrollCycle = `${payrollCycle}PostRollback`;

export const getEmployees = `${payRoll}GetEmployees`;
export const postSalaryStructure = `${payRoll}PostSalaryStructure`;
export const updateSalaryStructureByEmployeeCode = `${payRoll}UpdateSalaryStructureByEmployeeCode`;
export const updateSalaryStructureByRollnumber = `${payRoll}updateSalaryStructureByRollnumber`;
export const deleteSalaryStructureByEmployeeCode = `${payRoll}DeleteSalaryStructureByEmployeeCode`;
export const deleteSalaryStructureByRollnumber = `${payRoll}deleteSalaryStructureByRollnumber`;
export const salaryStructureDashboard = `${payRoll}GetSalaryStructureDashboard`;

export const postPFConfiguration = `${payRoll}PostPFConfiguration`;
export const postESIConfiguration = `${payRoll}PostESIConfiguration`;
export const postProfessionalTaxConfiguration = `${payRoll}PostProfessionalTaxConfiguration`;
export const postTDSConfiguration = `${payRoll}PostTDSConfiguration`;
export const getDeductionsAndCompliance = `${payRoll}GetDeductionsAndCompliance`;
export const employeeComplianceDashboard = `${payRoll}GetEmployeeComplianceDashboard`;
export const updateEmployeeComplianceByEmployeeCode = `${payRoll}UpdateEmployeeComplianceByEmployeeCode`;
export const updateEmployeeComplianceByRollnumber = `${payRoll}updateEmployeeComplianceByRollnumber`;

export const GetEmployeesMissingBankDetails = `${payRoll}GetEmployeesMissingBankDetails`;

export const approvePayrollPayslipsDashboard = `${payRoll}GetApprovePayrollPayslipsDashboard`;
export const getPayrollPayslipByRollNumber = `${payRoll}getPayrollPayslipByRollNumber`;

export const RequestPayslip = `${payRoll}RequestPayslip`;
export const GetMyPayslipRequests = `${payRoll}GetMyPayslipRequests`;
export const GetMyPayslip = `${payRoll}GetMyPayslip`;
export const GetPayslipRequests = `${payRoll}GetPayslipRequests`;
export const UpdatePayslipRequestAction = `${payRoll}UpdatePayslipRequestAction`;
export const ApproveAllPayslipRequests = `${payRoll}ApproveAllPayslipRequests`;

export const leavePolicyDashboard = `${payRoll}leavePolicyDashboard`;
export const postLeaveType = `${payRoll}postLeaveType`;
export const updateLeaveTypeById = `${payRoll}updateLeaveTypeById`;

export const GetSalaryAdvancesDashboard = `${SalaryAdvance}GetSalaryAdvancesDashboard`;
export const UpdateAdvanceRequestAction = `${SalaryAdvance}UpdateAdvanceRequestAction`;
export const GetAdvanceFormOptions = `${SalaryAdvance}GetAdvanceFormOptions`;
export const RequestAdvance = `${SalaryAdvance}RequestAdvance`;
export const GetMyAdvanceRequests = `${SalaryAdvance}GetMyAdvanceRequests`;

export const GetOvertimeDashboard = `${Overtime}GetOvertimeDashboard`;
export const AddOvertimeRateSlab = `${Overtime}AddOvertimeRateSlab`;
export const UpdateOvertimeRateSlab = `${Overtime}UpdateOvertimeRateSlab`;
export const DeleteOvertimeRateSlab = `${Overtime}DeleteOvertimeRateSlab`;
export const UpdateOvertimeCountsAfter = `${Overtime}UpdateOvertimeCountsAfter`;
export const UpdateSundayOvertime = `${Overtime}UpdateSundayOvertime`;
export const UpdateOvertimeEntryAction = `${Overtime}UpdateOvertimeEntryAction`;
export const RequestOvertime = `${Overtime}RequestOvertime`;
export const GetMyOvertimeRequests = `${Overtime}GetMyOvertimeRequests`;

export const postLeaveRequest = `${leave}PostLeaveRequest`;
export const getLeaveApprovalDashboard = `${leave}GetLeaveApprovalDashboard`;
export const GetLeaveApprovalStatusCheck = `${leave}GetLeaveApprovalStatusCheck`;
export const updateLeaveApprovalAction = `${leave}UpdateLeaveApprovalAction`;
export const leaveApprovalStatusCheck = `${baseApiurl}leaveApprovalStatusCheck`;
export const GetMyRequests = `${baseApiurl}MyRequests/GetMyRequests`;

export const postleavepolicy = `${leavePolicy}postleavepolicy`;
export const GetLeavePolicy = `${leavePolicy}GetLeavePolicy`;
export const postleavetypes = `${leavePolicy}postleavetypes`;
export const GetleaveTypes = `${leavePolicy}GetleaveTypes`;
export const postworkingcalendar = `${leavePolicy}postworkingcalendar`;
export const GetWorkingcalendar = `${leavePolicy}GetWorkingcalendar`;
export const UpdateleaveTypeByID = `${leavePolicy}UpdateleaveTypeByID`;
export const DeleteleaveTypeByID = `${leavePolicy}DeleteleaveTypeByID`;

export const reportsLeaveManagement = `${baseApiurl}Reports/GetReportsLeaveManagement`;
export const reportsLeaveManagementFullReport = `${baseApiurl}Reports/GetReportsLeaveManagementFullReport`;

export const getStaffAttendanceOverview = `${baseApiurl}teachersattendance/getStaffAttendanceOverview`;
export const GetAttendanceTeacherBefore = `${baseApiurl}teachersattendance/GetAttendanceTeacherBefore`;
export const GetTeachersAttendance = `${baseApiurl}teachersattendance/GetTeachersAttendance`;
export const PostTeachersManualAttendance = `${baseApiurl}teachersattendance/PostTeachersManualAttendance`;

export const SyncStatus = `${biometrics}SyncStatus/`;
export const TriggerManualSync = `${biometrics}TriggerManualSync/`;
export const GetBiometricMappings = `${biometrics}GetBiometricMappings/`;
export const PostBiometricMappings = `${biometrics}PostBiometricMappings/`;
export const UpdateBiometricMappings = `${biometrics}UpdateBiometricMappings/`;

export const GetStaffInformation = `${staffManagement}GetStaffInformation`;

export const UploadEmployeeDoc = `${EmployeeDocument}PostEmployeeDocument`;
export const GetEmployeeDocs = `${EmployeeDocument}GetEmployeeDocuments`;
export const GetDocumentTypes = `${EmployeeDocument}GetDocumentTypes`;
export const DownloadEmployeeDoc = `${EmployeeDocument}DownloadEmployeeDocument`;
export const DeleteEmployeeDoc = `${EmployeeDocument}DeleteEmployeeDocument`;

export const GetDepartments = `${Department}GetDepartments`;
export const CreateDepartment = `${Department}CreateDepartment`;
export const UpdateDepartment = `${Department}UpdateDepartment`;
export const DeleteDepartment = `${Department}DeleteDepartment`;

export const GetDesignations = `${Designation}GetDesignations`;
export const CreateDesignation = `${Designation}CreateDesignation`;
export const UpdateDesignation = `${Designation}UpdateDesignation`;
export const DeleteDesignation = `${Designation}DeleteDesignation`;

export const GetVacancies = `${Recruitment}GetVacancies`;
export const GetRecruitmentStats = `${Recruitment}GetRecruitmentStats`;
export const CreateVacancy = `${Recruitment}CreateVacancy`;
export const UpdateVacancy = `${Recruitment}UpdateVacancy`;
export const SetVacancyStatus = `${Recruitment}SetVacancyStatus`;
export const DeleteVacancy = `${Recruitment}DeleteVacancy`;

export const GetCandidates = `${Recruitment}GetCandidates`;
export const AddCandidate = `${Recruitment}AddCandidate`;
export const UpdateCandidate = `${Recruitment}UpdateCandidate`;
export const SetCandidateStage = `${Recruitment}SetCandidateStage`;
export const DeleteCandidate = `${Recruitment}DeleteCandidate`;

export const GetInterviews = `${Recruitment}GetInterviews`;
export const GetInterviewFormOptions = `${Recruitment}GetInterviewFormOptions`;
export const ScheduleInterview = `${Recruitment}ScheduleInterview`;
export const UpdateInterview = `${Recruitment}UpdateInterview`;
export const RescheduleInterview = `${Recruitment}RescheduleInterview`;
export const MarkInterviewConducted = `${Recruitment}MarkInterviewConducted`;
export const MarkInterviewNoShow = `${Recruitment}MarkInterviewNoShow`;
export const ReviewInterview = `${Recruitment}ReviewInterview`;
export const CancelInterview = `${Recruitment}CancelInterview`;

export const GetInterviewFieldDefinitions = `${Recruitment}GetInterviewFieldDefinitions`;
export const CreateInterviewFieldDefinition = `${Recruitment}CreateInterviewFieldDefinition`;
export const UpdateInterviewFieldDefinition = `${Recruitment}UpdateInterviewFieldDefinition`;
export const DeleteInterviewFieldDefinition = `${Recruitment}DeleteInterviewFieldDefinition`;
export const UploadInterviewFieldFile = `${Recruitment}UploadInterviewFieldFile`;

export const AddCandidateCommunication = `${Recruitment}AddCandidateCommunication`;
export const UpdateCandidateCommunication = `${Recruitment}UpdateCandidateCommunication`;
export const DeleteCandidateCommunication = `${Recruitment}DeleteCandidateCommunication`;
export const GetCandidateCommunications = `${Recruitment}GetCandidateCommunications`;
export const UploadCandidateResume = `${Recruitment}UploadCandidateResume`;

export const GetCandidateEmployments = `${Recruitment}GetCandidateEmployments`;
export const AddCandidateEmployment = `${Recruitment}AddCandidateEmployment`;
export const UpdateCandidateEmployment = `${Recruitment}UpdateCandidateEmployment`;
export const DeleteCandidateEmployment = `${Recruitment}DeleteCandidateEmployment`;

export const GetAuditLog = `${Recruitment}GetAuditLog`;

export const GetCareersSettings = `${Careers}GetCareersSettings`;
export const SaveCareersSettings = `${Careers}SaveCareersSettings`;
export const SetVacancyPublished = `${Careers}SetVacancyPublished`;

// Public (no login) careers-site endpoints.
export const publicCareersVacancies = (name) => `${PublicCareers}${encodeURIComponent(name)}/vacancies`;
export const publicCareersVacancy = (name, key) => `${publicCareersVacancies(name)}/${encodeURIComponent(key)}`;
export const publicCareersApply = (name, key) => `${publicCareersVacancy(name, key)}/apply`;
export const publicCareersTrack = (name) => `${PublicCareers}${encodeURIComponent(name)}/applications/status`;

export const GetInbox = `${Inbox}GetInbox`;
export const UpdateMessageReadStatus = `${Inbox}UpdateMessageReadStatus`;
export const MarkAllRead = `${Inbox}MarkAllRead`;
export const DeleteMessage = `${Inbox}DeleteMessage`;
export const ClearAll = `${Inbox}ClearAll`;

export const GetBusinessEntitiesDashboard = `${BusinessEntity}GetBusinessEntitiesDashboard`;
export const GetBusinessEntityById = `${BusinessEntity}GetBusinessEntityById`;
export const PostBusinessEntity = `${BusinessEntity}PostBusinessEntity`;
export const UpdateBusinessEntityById = `${BusinessEntity}UpdateBusinessEntityById`;
export const DeleteBusinessEntityById = `${BusinessEntity}DeleteBusinessEntityById`;
export const UploadBusinessEntityLogo = `${BusinessEntity}UploadBusinessEntityLogo`;
export const RemoveBusinessEntityLogo = `${BusinessEntity}RemoveBusinessEntityLogo`;

export const GetDocumentRequests = `${DocumentManagement}GetDocumentRequests`;
export const GetKnownDocumentTypes = `${DocumentManagement}GetKnownDocumentTypes`;
export const PostDocumentRequest = `${DocumentManagement}PostDocumentRequest`;
export const PostAddRecipients = `${DocumentManagement}PostAddRecipients`;
export const DeleteDocumentRequest = `${DocumentManagement}DeleteDocumentRequest`;
export const GetPendingApprovals = `${DocumentManagement}GetPendingApprovals`;
export const UpdateApprovalAction = `${DocumentManagement}UpdateApprovalAction`;
export const PostApproveAll = `${DocumentManagement}PostApproveAll`;
export const DownloadSubmission = `${DocumentManagement}DownloadSubmission`;
export const GetEmployeeDocuments = `${DocumentManagement}GetEmployeeDocuments`;
export const DownloadEmployeeDocument = `${DocumentManagement}DownloadEmployeeDocument`;
export const DeleteEmployeeDocument = `${DocumentManagement}DeleteEmployeeDocument`;
export const GetMyDocumentRequests = `${DocumentManagement}GetMyDocumentRequests`;
export const PostMyDocumentUpload = `${DocumentManagement}PostMyDocumentUpload`;

export const GetOrganisationDocuments = `${OrganisationDocuments}GetOrganisationDocuments`;
export const GetMyOrganisationDocuments = `${OrganisationDocuments}GetMyOrganisationDocuments`;
export const PostOrganisationDocument = `${OrganisationDocuments}PostOrganisationDocument`;
export const UpdateOrganisationDocument = `${OrganisationDocuments}UpdateOrganisationDocument`;
export const DeleteOrganisationDocument = `${OrganisationDocuments}DeleteOrganisationDocument`;
export const DownloadOrganisationDocument = `${OrganisationDocuments}DownloadOrganisationDocument`;

export const GetClientLocations = `${ClientLocation}GetClientLocations`;
export const GetClientLocationById = `${ClientLocation}GetClientLocationById`;
export const CreateClientLocation = `${ClientLocation}CreateClientLocation`;
export const UpdateClientLocation = `${ClientLocation}UpdateClientLocation`;
export const DeleteClientLocation = `${ClientLocation}DeleteClientLocation`;
export const GetLocationAssignments = `${ClientLocation}GetLocationAssignments`;
export const AssignLocation = `${ClientLocation}AssignLocation`;
export const UpdateLocationAssignment = `${ClientLocation}UpdateLocationAssignment`;
export const DeleteLocationAssignment = `${ClientLocation}DeleteLocationAssignment`;
export const GetMyAssignedLocations = `${ClientLocation}GetMyAssignedLocations`;

export const GetResignations = `${Resignation}GetResignations`;
export const SubmitResignation = `${Resignation}SubmitResignation`;
export const UpdateResignation = `${Resignation}UpdateResignation`;
export const SetResignationStatus = `${Resignation}SetResignationStatus`;
export const ApproveResignation = `${Resignation}ApproveResignation`;
export const CancelNoticePeriod = `${Resignation}CancelNoticePeriod`;
export const DeleteResignation = `${Resignation}DeleteResignation`;
export const GetMyResignation = `${Resignation}GetMyResignation`;

// Employee self-service: my own record, and a safe subset of it that I can edit.
export const GetMyProfile = `${MyProfile}GetMyProfile`;
export const UpdateMyProfile = `${MyProfile}UpdateMyProfile`;

// Growth increments (free-form, admin-managed). These endpoints are not on the server yet; names are a proposal.
// Regular increments: the yearly percentage plus per-person overrides ({ percent, overrides: [{ employeeCode, percent, amount }] }).
export const GetRegularIncrements = `${Increment}GetRegularIncrements`;
export const SaveRegularIncrements = `${Increment}SaveRegularIncrements`;
export const GetGrowthIncrements = `${Increment}GetGrowthIncrements`;
export const AddGrowthIncrement = `${Increment}AddGrowthIncrement`;
export const UpdateGrowthIncrement = `${Increment}UpdateGrowthIncrement`;
export const DeleteGrowthIncrement = `${Increment}DeleteGrowthIncrement`;
export const WithdrawResignation = `${Resignation}WithdrawResignation`;
export const GetFinalSettlement = `${Resignation}GetFinalSettlement`;
export const GetEmployeeFinalSettlement = `${Resignation}GetEmployeeFinalSettlement`;
export const GetResignationSetting = `${Resignation}GetResignationSetting`;
export const SaveResignationSetting = `${Resignation}SaveResignationSetting`;

export const GetMissedPunches = `${PunchRequest}GetMissedPunches`;
export const PostPunchRequest = `${PunchRequest}PostPunchRequest`;
export const GetMyPunchRequests = `${PunchRequest}GetMyPunchRequests`;
export const GetPunchRequests = `${PunchRequest}GetPunchRequests`;
export const ApprovePunchRequest = `${PunchRequest}ApprovePunchRequest`;
export const RejectPunchRequest = `${PunchRequest}RejectPunchRequest`;

export const GetLocationTrips = `${LocationTracking}GetLocationTrips`;
export const GetTripRoute = `${LocationTracking}GetTripRoute`;

export const GetSitePunches = `${SitePunch}GetSitePunches`;
export const GetMySitePunches = `${SitePunch}GetMySitePunches`;
export const DownloadPunchPhoto = `${SitePunch}DownloadPunchPhoto`;

// ---- Group Chat (see group-chat-integration.md) ----
// Groups
export const GetGroups = `${Chat}GetGroups`;
export const GetGroupInfo = `${Chat}GetGroupInfo`;
export const CreateGroup = `${Chat}CreateGroup`;
export const UpdateGroup = `${Chat}UpdateGroup`;
export const UpdateGroupMembers = `${Chat}UpdateGroupMembers`;
export const MuteGroup = `${Chat}MuteGroup`;
export const SearchUsers = `${Chat}SearchUsers`;
export const GetChatUsers = `${Chat}GetChatUsers`;
export const UpdateMemberRole = `${Chat}UpdateMemberRole`;
export const LeaveGroup = `${Chat}LeaveGroup`;
export const DeleteGroup = `${Chat}DeleteGroup`;
// Messages
export const SendMessage = `${Chat}SendMessage`;
export const FetchMessages = `${Chat}FetchMessages`;
// Named DeleteChatMessage (not DeleteMessage) to avoid colliding with the
// existing Inbox DeleteMessage export above.
export const DeleteChatMessage = `${Chat}DeleteMessage`;
export const EditMessage = `${Chat}EditMessage`;
export const ReactMessage = `${Chat}ReactMessage`;
export const PinMessage = `${Chat}PinMessage`;
export const MarkRead = `${Chat}MarkRead`;
export const ClearChat = `${Chat}ClearChat`;
export const FetchMedia = `${Chat}FetchMedia`;
export const SearchMessages = `${Chat}SearchMessages`;
export const GetMessageReadInfo = `${Chat}GetMessageReadInfo`;
// Group-create permission (MasterAdmin only to manage; read-only consumed here)
export const GetCreatePermissions = `${GroupChatSettings}GetCreatePermissions`;
export const SetCreatePermission = `${GroupChatSettings}SetCreatePermission`;

// ---- Added from collection 37: self-service documents, leave, payroll views, tracking, devices
export const PostMyDocument = `${MyDocument}PostMyDocument`;
export const UpdateMyDocument = `${MyDocument}UpdateMyDocument`; // + /{id}
export const GetMyDocuments = `${MyDocument}GetMyDocuments`;
export const GetMyDocumentById = `${MyDocument}GetMyDocumentById`; // + /{id}
export const DeleteMyDocument = `${MyDocument}DeleteMyDocument`; // + /{id}
export const CancelLeave = `${leave}CancelLeave`;
export const GetEmployeeAttendanceLeaveSummary = `${leave}GetEmployeeAttendanceLeaveSummary`;
export const GetSalaryBreakdownByEmployeeCode = `${payRoll}GetSalaryBreakdownByEmployeeCode`;
export const GetPayrollPayslipByEmployeeCode = `${payRoll}GetPayrollPayslipByEmployeeCode`;
export const PostOvertimeEntry = `${Overtime}PostOvertimeEntry`;
export const GetBiometricAttendanceLogs = `${biometrics}GetBiometricAttendanceLogs`;
export const GetMeetingPunches = `${biometrics}GetMeetingPunches`;
export const GetSyncSummary = `${biometrics}GetSyncSummary`;
export const GetActiveLocationTrips = `${LocationTracking}GetActiveLocationTrips`;
export const GetLocationTrackingConfig = `${LocationTracking}GetLocationTrackingConfig`;
export const SaveLocationTrackingConfig = `${LocationTracking}SaveLocationTrackingConfig`;
export const GetDeviceInfos = `${DeviceInfo}GetDeviceInfos`;
export const GetDeviceInfo = `${DeviceInfo}GetDeviceInfo`;
export const SendTodaysWishes = `${baseApiurl}Birthday/SendTodaysWishes`;

// ---- Expenses (Daily / Shoot / Other) + the shoot payment ledger
const Expenses = `${baseApiurl}Expenses/`;
export const GetDailyExpenses = `${Expenses}GetDailyExpenses`;
export const GetDailyExpenseCategories = `${Expenses}GetDailyExpenseCategories`;
export const AddDailyExpense = `${Expenses}AddDailyExpense`;
export const UpdateDailyExpense = `${Expenses}UpdateDailyExpense`;
export const DeleteDailyExpense = `${Expenses}DeleteDailyExpense`;
export const UpdateDailyExpenseCategory = `${Expenses}UpdateDailyExpenseCategory`;
export const GetDailyExpenseReminders = `${Expenses}GetDailyExpenseReminders`;
export const SetDailyExpenseReminder = `${Expenses}SetDailyExpenseReminder`;
export const DeleteDailyExpenseReminder = `${Expenses}DeleteDailyExpenseReminder`;
export const GetShootExpenses = `${Expenses}GetShootExpenses`;
export const GetShootExpenseCategories = `${Expenses}GetShootExpenseCategories`;
export const AddShootExpense = `${Expenses}AddShootExpense`;
export const UpdateShootExpense = `${Expenses}UpdateShootExpense`;
export const DeleteShootExpense = `${Expenses}DeleteShootExpense`;
export const UpdateShootExpenseCategory = `${Expenses}UpdateShootExpenseCategory`;
export const GetShootPayments = `${Expenses}GetShootPayments`;
export const AddShootPayment = `${Expenses}AddShootPayment`;
export const DeleteShootPayment = `${Expenses}DeleteShootPayment`;
export const GetEmployeeShootNames = `${Expenses}GetEmployeeShootNames`;
export const GetShootPaymentHistoryOverview = `${Expenses}GetShootPaymentHistoryOverview`;
export const GetEmployeePaymentHistory = `${Expenses}GetEmployeePaymentHistory`;
export const GetOtherExpenses = `${Expenses}GetOtherExpenses`;
export const GetOtherExpenseCategories = `${Expenses}GetOtherExpenseCategories`;
export const AddOtherExpense = `${Expenses}AddOtherExpense`;
export const UpdateOtherExpense = `${Expenses}UpdateOtherExpense`;
export const DeleteOtherExpense = `${Expenses}DeleteOtherExpense`;
export const UpdateOtherExpenseCategory = `${Expenses}UpdateOtherExpenseCategory`;

// ---- Payroll incentives (ad-hoc one-off amounts per payout month)
const PayrollIncentive = `${baseApiurl}PayrollIncentive/`;
export const AddPayrollIncentive = `${PayrollIncentive}AddPayrollIncentive`;
export const UpdatePayrollIncentive = `${PayrollIncentive}UpdatePayrollIncentive`;
export const DeletePayrollIncentive = `${PayrollIncentive}DeletePayrollIncentive`;
export const GetPayrollIncentives = `${PayrollIncentive}GetPayrollIncentives`;

// ---- Salary security (encrypted salary figures) + gross-salary component split
const SalarySecurity = `${baseApiurl}SalarySecurity/`;
export const GetSalarySecurityStatus = `${SalarySecurity}Status`;
export const PostSalarySecuritySetup = `${SalarySecurity}Setup`;
export const PostSalaryChangePassphrase = `${SalarySecurity}ChangePassphrase`;
export const PostSalaryResetViaRecovery = `${SalarySecurity}ResetViaRecovery`;
export const PostSalaryRotateRecoveryKey = `${SalarySecurity}RotateRecoveryKey`;
export const GetSalaryComponentConfig = `${payRoll}GetSalaryComponentConfig`;
export const PostSalaryComponentConfig = `${payRoll}PostSalaryComponentConfig`;
